import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { Subject, finalize, takeUntil } from 'rxjs';
import { TradingService } from '../trading.service';
import { BrokrageService } from '@service/brokrage.service';

@Component({
  selector: 'app-price-feed-broker-dialog',
  templateUrl: './price-feed-broker-dialog.component.html',
  styleUrls: ['./price-feed-broker-dialog.component.scss']
})
export class PriceFeedBrokerDialogComponent implements OnInit {

  _unsubscribeAll = new Subject();
  brokrageList: any[] = [];
  liveFeedData: any
  isBrokerLoading: boolean = false
  constructor(
    private dialogRef: MatDialogRef<PriceFeedBrokerDialogComponent>,
    private alertService: AlertService,
    private authService: AuthService,
    private tradingService: TradingService,
    private brokerageService: BrokrageService
  ) { }

  ngOnInit(): void {
    this.isBrokerLoading = true
    this.alertService.getBrokerageHouses().pipe(takeUntil(this._unsubscribeAll),finalize(()=> this.isBrokerLoading = false)).subscribe((res: any) => {
      this.brokrageList = res || [];
    })
    this.getLiveFeedData()
  }
  getLiveFeedData(){
    this.isBrokerLoading = true
    this.authService.getLiveFeed().pipe(finalize(()=> this.isBrokerLoading = false)).subscribe((res)=>{
      this.liveFeedData = res
    })
  }
  closeDialog(){
    this.dialogRef.close()
  }
  selectBroker(broker) {
    const data = {
      brokerageOptions: [broker.code]
    };
    this.isBrokerLoading = true
    this.tradingService.updateBrokerage(data).pipe(finalize(() => this.isBrokerLoading = false)).subscribe(
      (res: any) => {
        this.authService.UpdateUserData(false);
        this.brokerageService.gotoBrokerLogin(broker.code)
      }
    );
  }
}
